var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"common-form"},[_vm._v("其它")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"限购数量","prop":"limit_num","rules":[{ required: true, message: '请填写限购数量' }]}},[_c('el-input',{staticClass:"max-w460",attrs:{"type":"number"},model:{value:(_vm.form.limit_num),callback:function ($$v) {_vm.$set(_vm.form, "limit_num", $$v)},expression:"form.limit_num"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-305830ec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/activity/bargain/part/Other.vue
// module id = null
// module chunks = 